import React from 'react';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const UkassaTeam = () => {
    return (
        <div className="ukassa-team">
            <ScrollAnimation
                delay={0}
                animateIn="fadeIn"
                offset={100}
                animateOnce={true}
                duration={1}
            >
                <FullWrapper bigPaddings isMargin={false}>
                    <div className="ukassa-team__content">
                        <span className="ukassa-team__title">Команда</span>
                        <span className="ukassa-team__text">
                            Команда из 8 человек закрывает все необходимые компетенции от аналитиков
                            до разработчиков.
                        </span>
                        <img
                            src="/images/svg/ukassa/team.svg"
                            alt=""
                            className="ukassa-team__img"
                            loading="lazy"
                        />
                    </div>
                </FullWrapper>
            </ScrollAnimation>
        </div>
    );
};

export default UkassaTeam;
